const teamBuying = {
  state: () => ({
    list: [],
    isFetched: false,
    isFetching: false
  }),
  mutations: {},
  actions: {},
  getters: {}
}
export default teamBuying
